<template>
  <div id="app">
    <router-link to="/"></router-link>
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.reset();
  },

  methods: {
    device() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) return "android";
      if (isiOS) return "ios";
    },

    reset() {
      let isReset = true;

      if (this.device() === "ios") {
        document.body.addEventListener("focusin", () => {
          //软键盘弹出的事件处理
          isReset = false;
        });
        document.body.addEventListener("focusout", () => {
          //软键盘收起的事件处理
          isReset = true;
          setTimeout(() => {
            //当焦点在弹出层的输入框之间切换时先不归位
            if (isReset) {
              window.scroll(0, 0); //失焦后强制让页面归位
            }
          }, 300);
        });
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<style>
html,body,#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
</style>
